import { Box, Modal, Paper } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectLabels } from "../../../slices/language";
import IconifyIcon from "../../IconifyIcon";

interface ImageModalProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  srcImage: string;
  imageType: string;
  visitorName: string;
}

const ImageModal = ({
  showModal,
  setShowModal,
  srcImage,
  imageType,
  visitorName,
}: ImageModalProps) => {
  const labels = useAppSelector(selectLabels);

  const imgType =
    imageType === "photo id"
      ? labels.id
      : imageType === "plates"
      ? labels.plates
      : imageType === "visitor"
      ? labels.visitor
      : imageType === "equipment"
      ? labels.equipment
      : "";

  return (
    <Modal
      open={showModal}
      onClose={(event) => {
        (event as React.MouseEvent<HTMLDivElement>).stopPropagation();
        setShowModal(false);
      }}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          outline: 0,
        }}
      >
        <Paper
          style={{
            maxWidth: 800,
            minWidth: 350,
            width: "100%",
            maxHeight: "90vh",
            boxSizing: "border-box",
            padding: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            overflow: "hidden",
            outline: 0,
          }}
        >
          <div
            className="w-100 border-box flex flex-dir-col align-items-center justify-content-between"
            style={{ minHeight: 0, flex: 1 }}
          >
            <div
              className="w-100 flex justify-content-between"
              style={{ height: 40, minHeight: 40, flexShrink: 0, alignItems: "flex-start" }}
            >
              <div>
                <p className="font-16 font-w-700 subtitle-color m-0 p-0">
                  {visitorName}
                </p>
                <p className="font-14 subtitle-color m-0 p-0">
                  {labels.photo}: {imgType}
                </p>
              </div>
              <IconifyIcon
                icon={"material-symbols:close"}
                className="subtitle-color pointer"
                style={{ fontSize: 22 }}
                onClick={() => setShowModal(false)}
              />
            </div>
            <div
              className="w-100"
              style={{
                flex: 1,
                minHeight: 0,
                maxHeight: "calc(90vh - 60px)",
                borderRadius: 4,
                overflow: "hidden",
                border: "1px #dfdfdf solid",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={srcImage}
                alt=""
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </Paper>
      </Box>
    </Modal>
  );
};

export default ImageModal;
